import { defineMessages } from 'react-intl';

export default defineMessages({
  clearButton: {
    id: 'components.eSignature.clearButton',
    defaultMessage: 'Clear',
  },
});
